import type { mockRatingHistoryViewModel } from './ratingHistory.type';

export const mockRatingHistoryData: mockRatingHistoryViewModel = {
  ratingHistory: [
    {
      id: 1,
      ratingDate: new Date('2025-01-01T00:00:00'),
      expirationDate: new Date('2026-01-01T00:00:00'),
      mod: 3.56,
      arap: 4.31,
      status: 'Does not qualify',
      riskID: null,
      isPreliminary: true,
      attachment: 'getdoc.pdf',
    },
    {
      id: 2,
      ratingDate: new Date('2024-01-01T00:00:00'),
      expirationDate: new Date('2025-01-01T00:00:00'),
      mod: 3.56,
      arap: 4.31,
      status: 'NCCI issued',
      riskID: '456789512',
      isPreliminary: false,
      attachment: 'getdoc.pdf',
    },
    {
      id: 3,
      ratingDate: new Date('2023-01-01T00:00:00'),
      expirationDate: new Date('2024-01-01T00:00:00'),
      mod: 3.56,
      arap: 4.31,
      status: 'Not final [MOCK]',
      riskID: null,
      isPreliminary: false,
      attachment: 'getdoc.pdf',
    },
    {
      id: 4,
      ratingDate: new Date('2022-01-01T00:00:00'),
      expirationDate: new Date('2023-01-01T00:00:00'),
      mod: 3.46,
      arap: 4.28,
      status: 'NC issued [MOCK]',
      riskID: null,
      isPreliminary: false,
      attachment: 'getdoc.pdf',
    },
    {
      id: 5,
      ratingDate: new Date('2021-01-01T00:00:00'),
      expirationDate: new Date('2022-01-01T00:00:00'),
      mod: null,
      arap: 4.26,
      status: 'Not ready',
      riskID: null,
      isPreliminary: false,
      attachment: null,
    },
    {
      id: 6,
      ratingDate: new Date('2020-01-01T00:00:00'),
      expirationDate: new Date('2021-01-01T00:00:00'),
      mod: 3.86,
      arap: 4.19,
      status: 'Not final',
      riskID: null,
      isPreliminary: false,
      attachment: null,
    },
    {
      id: 7,
      ratingDate: new Date('2019-01-01T00:00:00'),
      expirationDate: new Date('2020-01-01T00:00:00'),
      mod: 3.16,
      arap: 4.2,
      status: 'Does not qualify',
      riskID: null,
      isPreliminary: false,
      attachment: 'getdoc.pdf',
    },
    {
      id: 8,
      ratingDate: new Date('2018-01-01T00:00:00'),
      expirationDate: new Date('2019-01-01T00:00:00'),
      mod: 3.2,
      arap: 3.89,
      status: 'Ineligible',
      riskID: null,
      isPreliminary: false,
      attachment: 'getdoc.pdf',
    },
    {
      id: 9,
      ratingDate: new Date('2017-01-01T00:00:00'),
      expirationDate: new Date('2018-01-01T00:00:00'),
      mod: 3.16,
      arap: 4.19,
      status: 'Not final',
      riskID: null,
      isPreliminary: false,
      attachment: 'getdoc.pdf',
    },
  ],
};
